var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportExportNavIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.844,
    height: 24,
    viewBox: "0 0 24.844 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8674",
    "data-name": "Group 8674",
    transform: "translate(-19.394 -351)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2999",
    "data-name": "Rectangle 2999",
    width: 24,
    height: 24,
    transform: "translate(20 351)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "connection_3_",
    "data-name": "connection (3)",
    d: "M69.18,85.528l-7.133-7.134a.421.421,0,0,0-.719.3V82.7H55.386a.421.421,0,1,0,0,.843h6.362a.421.421,0,0,0,.421-.421V79.709l6.119,6.119L62.17,91.941V88.529a.421.421,0,0,0-.421-.421H52.909V84.1a.421.421,0,0,0-.719-.3l-7.133,7.134a.421.421,0,0,0,0,.6l7.133,7.134a.422.422,0,0,0,.3.124.414.414,0,0,0,.161-.032.421.421,0,0,0,.26-.389V94.36H58.85a.421.421,0,0,0,0-.842H52.488a.421.421,0,0,0-.421.421V97.35l-6.116-6.116,6.119-6.119v3.415a.421.421,0,0,0,.421.421h8.836v4.007a.421.421,0,0,0,.719.3l7.133-7.133a.421.421,0,0,0,0-.6Z",
    transform: "translate(-25.303 274.471)",
    fill: "currentColor",
    stroke: "#fff",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportExportNavIcon);
export default __webpack_public_path__ + "static/media/import-export-nav-icon.878cab9d6d08d9a0d7e74f763ba041d5.svg";
export { ForwardRef as ReactComponent };